import { useQuery } from '@tanstack/react-query';
import type { UsageSummary } from '@storeflare/types';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Page } from '@/components/Page';
import { api } from '@/lib/api';

export function UsagePage() {
  const usage = useQuery({
    queryKey: ['usage', 'detail'],
    queryFn: () => api<UsageSummary>('/v1/usage'),
  });

  return (
    <Page title="Usage" subtitle="Aggregated counters for the last 30 days.">
      {usage.isLoading ? (
        <Skeleton className="h-40 w-full" />
      ) : (
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
          <Item label="Storage" value={`${usage.data?.storage_bytes ?? 0} bytes`} />
          <Item label="Uploads" value={String(usage.data?.upload_count ?? 0)} />
          <Item label="Transform calls" value={String(usage.data?.transform_calls ?? 0)} />
          <Item label="Bandwidth in" value={`${usage.data?.bandwidth_in_bytes ?? 0} bytes`} />
          <Item label="Bandwidth out" value={`${usage.data?.bandwidth_out_bytes ?? 0} bytes`} />
        </div>
      )}
    </Page>
  );
}

function Item({ label, value }: { label: string; value: string }) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardDescription className="text-xs uppercase tracking-wide">{label}</CardDescription>
        <CardTitle className="text-lg">{value}</CardTitle>
      </CardHeader>
      <CardContent className="pt-0" />
    </Card>
  );
}
